import React, { ReactNode } from "react";
import { Form } from "react-bootstrap";
import { IDefaultInput } from "../interfaces/default.interface";
import FieldError from "../components/FieldError";
import { IOptionsSelect } from "../interfaces/options.interface";
import LLabel from "../LLabel";
import "./styles.css";
import "../styles.css";

interface LSelectProps extends IDefaultInput {
  options: IOptionsSelect[];
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  touched?: Record<string, boolean>;
  disabled?: boolean;
  extraComponent?: ReactNode;
  onBlur?: () => void;
}

const LSelect: React.FC<LSelectProps> = ({
  id,
  name,
  label,
  options,
  value,
  onChange,
  error = null,
  onBlur,
  disabled = false,
  isInvalid = false,
  required = false,
  className = "",
  size = "md",
  extraComponent,
}) => {
  const fieldName = name ?? id ?? "";

  return (
    <div className={`form-group flex-grow-1 ${className}`}>
      {label && <LLabel label={label} required={required} />}
      <div className="extra-component">
        <Form.Select
          id={id}
          name={fieldName}
          className={`form-control form-control-${size} ${isInvalid ? " is-invalid" : ""}`}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
        >
          <option value="">Selecione uma opção</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Form.Select>
        {extraComponent}
      </div>
      {error && isInvalid && <FieldError text={error} />}
    </div>
  );
};

export default LSelect;
